import React from "react";
import { Sparkles } from "lucide-react";
import { Separator } from "@/components/ui/separator";

const MOBILE_ITEMS = [
  { path: "/dashboard", label: "Dashboard", classes: "text-gray-300 hover:text-purple-400", testid: "mobile-nav-dashboard" },
  { path: "/documents", label: "Documentos", classes: "text-gray-300 hover:text-purple-400", testid: "mobile-nav-documents" },
  { path: "/social", label: "Escucha Social", classes: "text-gray-300 hover:text-purple-400", testid: "mobile-nav-social" },
  { path: "/social-studio", label: "Social Studio", classes: "text-pink-400 hover:text-pink-300", testid: "mobile-nav-social-studio" },
  { path: "/social-connect", label: "Social Connect", classes: "text-violet-400 hover:text-violet-300", testid: "mobile-nav-social-connect" },
  { path: "/media-directory", label: "Media Directory", classes: "text-amber-400 hover:text-amber-300", testid: "mobile-nav-media-directory" },
  { path: "/pr-toolkit", label: "PR Toolkit", classes: "text-cyan-400 hover:text-cyan-300", testid: "mobile-nav-pr-toolkit" },
  { path: "/sentiment", label: "Sentiment Engine", classes: "text-emerald-400 hover:text-emerald-300", testid: "mobile-nav-sentiment" },
  { path: "/intelligence", label: "Intelligence Radar", classes: "text-rose-400 hover:text-rose-300", testid: "mobile-nav-intelligence" },
  { path: "/risk", label: "Risk Engine", classes: "text-amber-400 hover:text-amber-300", testid: "mobile-nav-risk" },
  { path: "/alerts", label: "Alertas", classes: "text-gray-300 hover:text-purple-400", testid: "mobile-nav-alerts" },
  { path: "/history", label: "Historial", classes: "text-gray-300 hover:text-purple-400", testid: "mobile-nav-history" },
];

export const MobileMenu = ({ navigate, onClose, handleLogout }) => {
  const go = (path) => () => { navigate(path); onClose(); };
  return (
    <div className="md:hidden glass border-t border-white/10">
      <div className="px-4 py-4 space-y-3">
        <button
          onClick={() => {
            window.dispatchEvent(new CustomEvent("proxima:open-officers"));
            onClose();
          }}
          className="flex items-center gap-2 w-full text-left text-sm text-purple-300 font-semibold hover:text-purple-200"
          data-testid="mobile-nav-ai-officers"
        >
          <Sparkles className="w-4 h-4" />
          AI Officers
        </button>

        {MOBILE_ITEMS.map((item) => (
          <button
            key={item.path}
            onClick={go(item.path)}
            className={`block w-full text-left text-sm ${item.classes}`}
            data-testid={item.testid}
          >
            {item.label}
          </button>
        ))}

        <Separator className="bg-white/10" />
        <button
          onClick={go("/profile")}
          className="block w-full text-left text-sm text-purple-400 hover:text-purple-300"
          data-testid="mobile-nav-profile"
        >
          Mi Cuenta
        </button>
        <button
          onClick={handleLogout}
          className="block w-full text-left text-sm text-red-400 hover:text-red-300"
          data-testid="mobile-logout-button"
        >
          Cerrar Sesion
        </button>
      </div>
    </div>
  );
};
